var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"card-grid"},[_vm._l((_vm.cards),function(item){return _c('div',{key:item.title,staticClass:"card",attrs:{"click":() => _vm.$router.push(item.href)}},[_c('i',{class:item.icon}),_c('p',[_vm._v(_vm._s(item.title))])])}),_vm._m(0)],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-button"},[_c('i',{staticClass:"el-icon-plus"})])
}]

export { render, staticRenderFns }